import {formatString} from '@optimaxdev/utils';

export const CHECKOUT_DELIVERY_STEP = {
    action: 'Step 1 - Delivery',
    category: formatString('Checkout - {{version}}'),
    label: formatString('{{message}}'),
    name: 'Checkout',
};

export const CHECKOUT_RISKIFIED = {
    action: 'Riskified',
    category: formatString('Checkout - {{version}}'),
    label: formatString('{{message}}'),
    name: 'Checkout',
};

export const CHECKOUT_PAYMENT_STEP = {
    action: formatString('Step 2 - {{method}}'),
    category: formatString('Checkout - {{version}}'),
    label: formatString('{{message}}'),
    name: 'Checkout',
};

export const CHECKOUT_PLACE_ORDER_PAYMENT_STEP = {
    action: formatString('Step 2 - Place Order - {{method}}'),
    category: formatString('Checkout - {{version}}'),
    label: formatString('{{message}}'),
    name: 'Checkout',
};

export const CHECKOUT_PLACE_MY_ORDER = {
    action: formatString('Step 2 - Payment'),
    category: formatString('Checkout - {{version}}'),
    label: formatString('CTA - Place My Order - {{method}}'),
    name: 'Checkout',
};

export const CHECKOUT_ARBITRARY = {
    action: formatString('{{action}}'),
    category: formatString('Checkout - {{version}}'),
    label: formatString('{{label}}'),
    name: 'Checkout',
};

export const CHECKOUT_SIDE_BAR = {
    action: 'Side Bar',
    category: formatString('Checkout - {{version}}'),
    label: formatString('{{message}}'),
    name: 'Checkout',
};

export const CHECKOUT_ERRORS = {
    action: 'Errors',
    category: formatString('Checkout - {{version}}'),
    label: formatString('Step {{step}} - {{message}}'),
    name: 'Checkout',
};

export const CHECKOUT_GENERAL = {
    action: 'General',
    category: formatString('Checkout - {{version}}'),
    label: formatString('{{message}}'),
    name: 'Checkout',
};

export const CHECKOUT_REVIEW_STEP = {
    action: 'Step 3 - Review Order',
    category: formatString('Checkout - {{version}}'),
    label: formatString('{{message}}'),
    name: 'Checkout',
};

export const CHECKOUT_ORDER_SUMMARY = {
    action: formatString('Order Summary'),
    category: formatString('Checkout - {{version}}'),
    label: formatString('{{label}}'),
    name: 'Checkout',
};

export const PRIMER_ON_CHECKOUT_COMPLETE = {
    action: 'Primer onCheckoutComplete',
    category: formatString('Checkout - {{version}}'),
    label: formatString('payment ID - {{externalPaymentID}}, order id - {{orderId}}'),
    name: 'Checkout',
};

export const PRIMER_ON_CHECKOUT_FAIL = {
    action: 'Primer onCheckoutFail',
    category: formatString('Checkout - {{version}}'),
    label: formatString(
        'id - {{externalPaymentID}}, diagnosticsId - {{diagnosticsId}}, errorID - {{errorID}}',
    ),
    name: 'Checkout',
};

export const PRIMER_SAVE_ORDER_FAILED_REASON = {
    action: 'saveOrder failed',
    category: formatString('Checkout - {{version}}'),
    label: formatString(
        'payment ID - {{externalPaymentID}}, order ID - {{orderId}}, error {{errorCode}}, response status {{status}}',
    ),
    name: 'Checkout',
};

export const SUBSCRIPTION_CONSENT_SHOWED = {
    action: formatString('{{eventAction}} Subscription Consent'),
    category: formatString('Checkout - {{version}}'),
    label: formatString('Showed - {{label}}'),
    name: 'Checkout',
};

export const SUBSCRIPTION_CONSENT_EVENT = {
    action: formatString('{{eventAction}} Subscription Consent'),
    category: formatString('Checkout - {{version}}'),
    label: formatString('{{eventType}} - CTA Clicked - {{label}}'),
    name: 'Checkout',
};
